import { Link } from 'react-router-dom'
import psem_2025 from './2025_Pesem/portada.jpg'

export default function Index() {
  const temas = [   
    {
      nombre: 'PESEM 2025',
      imagen: psem_2025,
      texto: 'Plan estrategico empresarial 2025',
      ruta: '/galeria/gestion-financiera/pesem-2025',
    }
  ];

  return (
    <div className='container mt-4'>
      <div className='row justify-content-center'>
        <div className='pb-3 text-center'><h4>Galerias - Gestión financiera</h4></div>
        <div className='border-top border-3 mb-3'></div>
        {temas.map((t, i) => (
          <div key={i} className='col-12 col-sm-6 col-md-4 col-lg-2 mb-4'>
            <Link to={t.ruta} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card h-100">
                <img src={t.imagen} className="card-img-top" alt={t.nombre} />
                <div className="card-body">
                  <h6 className="fw-bold">{t.nombre}</h6>
                  <p className="card-text">{t.texto}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
